import { render, staticRenderFns } from "./id.vue?vue&type=template&id=0c8e25ad&scoped=true&"
import script from "./id.vue?vue&type=script&lang=js&"
export * from "./id.vue?vue&type=script&lang=js&"
import style0 from "./id.vue?vue&type=style&index=0&id=0c8e25ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8e25ad",
  null
  
)

export default component.exports